import React, { useEffect, 
      //  useState
              } from 'react';

import { Col, Divider, Row, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const ProyectosInvestigacion = ({ core }) => {
  useEffect(() => {
    document.title = 'Proyectos de Investigación | SALUDATA';
  }, []);

  return (
    <Row justify="center" style={{ marginTop: '50px' }}>
      <Col xxl={20} md={24}>
        <Title className="bold" level={1}>
          Proyectos de investigación cofinanciados por la Secretaria Distrital de Salud
        </Title>
        <Title level={5} style={{ color: '#515152' }}>
          Aquí encontrará los proyectos de investigación que han sido cofinanciados por la Secretaria Distrital de Salud a través de la agencia ATENEA desde el 2021.
        </Title>
        <Divider />
        


              
              {/* Enlace para pantalla completa
              <div style={{ 
                textAlign: 'right', 
                marginBottom: '15px'
              }}>
                <a 
                  href="https://app.powerbi.com/reportEmbed?reportId=bef7409b-0f2b-4638-8ab0-0a3c805618df&autoAuth=true&ctid=4ab1183e-75d6-4b87-b4b5-bfcb968c1d57" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    color: '#1890ff',
                    textDecoration: 'none',
                    fontSize: '16px',
                    fontWeight: '500',
                    padding: '8px 16px',
                    border: '1px solid #1890ff',
                    borderRadius: '4px',
                    backgroundColor: '#fff',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#1890ff';
                    e.target.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#fff';
                    e.target.style.color = '#1890ff';
                  }}
                >
                  📊 Ver en Pantalla Completa
                </a>
              </div>
 */}

        {/* Sección Central - Tablero Power BI */}
        <Row justify="center" style={{ marginBottom: '30px' }}>
          <Col span={24}>
            <div style={{ 
              border: '1px solid #d9d9d9', 
              borderRadius: '8px', 
              padding: '20px',
              backgroundColor: '#fafafa'
            }}>
              <Title level={4} style={{ marginBottom: '20px', textAlign: 'center' }}>
                {/* Tablero Interactivo de Power BI */}
              </Title>
              {/* Tablero de Power BI */}
              <div style={{ 
                width: '100%', 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '12px'
              }}>
                <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end', marginBottom: 8}}>
                  <button
                    onClick={() => {
                      const iframe = document.getElementById('pbi-iframe');
                      if (iframe.requestFullscreen) {
                        iframe.requestFullscreen();
                      } else if (iframe.mozRequestFullScreen) { /* Firefox */
                        iframe.mozRequestFullScreen();
                      } else if (iframe.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                        iframe.webkitRequestFullscreen();
                      } else if (iframe.msRequestFullscreen) { /* IE/Edge */
                        iframe.msRequestFullscreen();
                      }
                    }}
                    style={{
                      background: '#1890ff',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 4,
                      padding: '6px 16px',
                      fontWeight: 500,
                      cursor: 'pointer',
                      fontSize: 16
                    }}
                  >
                    🖥️ Pantalla Completa
                  </button>
                </div>
                <iframe 
                  id="pbi-iframe"
                  title="PBI Proyectos apoyados por SDS y Atena" 
                  width="100%" 
                  height="600" 
                  src="https://app.powerbi.com/view?r=eyJrIjoiOTVjZGI2MzgtYmIyZC00NmNlLWJhNjMtODEwZDY0M2I5MTBjIiwidCI6IjRhYjExODNlLTc1ZDYtNGI4Ny1iNGI1LWJmY2I5NjhjMWQ1NyIsImMiOjR9" 
                  frameBorder="0" 
                  allowFullScreen="true"
                  style={{
                    border: '1px solid #e8e8e8',
                    borderRadius: '4px',
                    width: '100%',
                    minHeight: 400,
                    maxWidth: '1625px',
                    background: '#fff'
                  }}
                ></iframe>
              </div>
            </div>
          </Col>
        </Row>


        {/* Sección Superior - Texto Explicativo */}
        <Row justify="center" style={{ marginBottom: '30px' }}>
          <Col span={24}>
            <Title level={3} className="bold">
              Tablero de Proyectos y productos de conocimiento en investigación en salud
            </Title>
            <Paragraph style={{ fontSize: '16px', lineHeight: '1.6' }}>
              Este tablero interactivo presenta una compilación integral de proyectos y artículos científicos 
              patrocinados por la <strong>Secretaria Distrital de Salud de Bógota</strong> y <strong>ATENEA</strong>. 
              La información está organizada de manera sistemática incluyendo:
            </Paragraph>
            <ul style={{ fontSize: '16px', lineHeight: '1.6', marginLeft: '20px' }}>
              <li><strong>Bibliografía por proyecto:</strong> referencias completas de cada investigación.</li>
              <li><strong>Autores:</strong> investigadores principales y colaboradores.</li>
              <li><strong>Instituciones:</strong> entidades ejecutoras de los proyectos.</li>
              <li><strong>Grupos de investigación:</strong> conjunto de personas que interactúan para investigar y generar productos de conocimiento en uno o varios temas, de acuerdo con un plan de trabajo de corto, mediano o largo plazo <em>(MINCIENCIAS).</em></li>
              <li><strong>Investigadores:</strong> perfiles detallados de los autores.</li>
            </ul>
            <Paragraph style={{ fontSize: '16px', lineHeight: '1.6' }}>
              Los datos corresponden a los últimos 3 años y se presentan de forma dinámica para facilitar 
              la consulta y análisis de la producción científica en salud de Bogotá.
            </Paragraph>
          </Col>
        </Row>
        {/* Sección Inferior - Información de Actualización */}
        <Row justify="center">
          <Col span={24}>
            <Divider />
            <div style={{ 
              backgroundColor: '#f0f8ff', 
              padding: '20px', 
              borderRadius: '8px',
              border: '1px solid #bae7ff'
            }}>
              <Title level={4} style={{ color: '#1890ff', marginBottom: '15px' }}>
                Información de Actualización
              </Title>
              <Paragraph style={{ fontSize: '16px', lineHeight: '1.6', marginBottom: '10px' }}>
                <strong>Frecuencia de actualización:</strong> El tablero se actualiza periódicamente para 
                mantener la información más reciente sobre los proyectos de investigación en salud.
              </Paragraph>
              <Paragraph style={{ fontSize: '16px', lineHeight: '1.6', marginBottom: '10px' }}>
                <strong>Próxima actualización:</strong> "30 noviembre 2025"
              </Paragraph>
              <Paragraph style={{ fontSize: '14px', color: '#666', fontStyle: 'italic' }}>
                Para consultas específicas sobre la información del tablero, por favor contacte al equipo 
                de investigación de SALUDATA.
              </Paragraph>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ProyectosInvestigacion; 